// extracted by mini-css-extract-plugin
module.exports = {"button":"admin_button__czGDG","danger":"admin_danger__9fp6e","shell":"admin_shell__3ON3_"};